import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { theme } from "../../theme";

const AuthDialogBox = ({ open, onClose, children }) => {
  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose && onClose(event, reason);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      maxWidth={false}
      aria-labelledby="auth-dialog-title"
      slotProps={{
        paper: {
          sx: {
            borderRadius: "20px",
            backgroundColor: theme.palette.background,
            width: { xs: "95%", sm: 390, md: 430, lg: 470 },
            maxWidth: 490,
            maxHeight: "90vh",
          },
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          zIndex: 1300,
          color: (theme) => theme.palette.grey[700],
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 1)",
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ p: 0, overflow: "auto" }}>{children}</DialogContent>
    </Dialog>
  );
};

export default AuthDialogBox;



